export default function notSet(value) {
    return !value
        && value !== false && value !== "false"
        && value !== 0 && value !== "0";
}
